import script from "./DBOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DBOptions.vue?vue&type=script&setup=true&lang=ts"

import "./DBOptions.vue?vue&type=style&index=0&id=6cc0507b&lang=css"

const __exports__ = script;

export default __exports__